import { render, staticRenderFns } from "./BaseForgetPwd.vue?vue&type=template&id=ccceb4c6&scoped=true&"
import script from "./BaseForgetPwd.vue?vue&type=script&lang=js&"
export * from "./BaseForgetPwd.vue?vue&type=script&lang=js&"
import style0 from "./BaseForgetPwd.vue?vue&type=style&index=0&id=ccceb4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccceb4c6",
  null
  
)

export default component.exports